import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
export function AgentPipelineSection() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-white border-t border-gray-100" data-id="element-92">
      <div className="max-w-7xl mx-auto" data-id="element-93">
        <div className="mb-16" data-id="element-94">
          <span className="text-sm font-bold tracking-widest uppercase text-[#0066FF] mb-4 block font-sans" data-id="element-95">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Syne'] leading-tight" data-id="element-96">
            Extract. Govern. Monitor.
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl" data-id="element-97">
            Three capabilities, one platform. Synthia captures institutional
            intelligence, encodes it into enforceable constitutions, and
            monitors agent fidelity in real time. When drift is detected,
            correction is automatic.
          </p>
        </div>

        {/* Pipeline Steps */}
        <div className="flex flex-col lg:flex-row gap-8 items-center mb-10" data-id="element-98">
          {/* Step 1 */}
          <div className="flex-1 w-full bg-gray-50 border border-gray-200 rounded-lg p-8 relative" data-id="element-99">
            <span className="text-xs font-mono text-gray-400 mb-2 block" data-id="element-100">
              Step 1
            </span>
            <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Syne']" data-id="element-101">
              Extract
            </h3>
            <span className="inline-block px-2 py-1 bg-blue-100 text-blue-700 text-xs font-bold rounded mb-4" data-id="element-102">
              Meetsynthia MCP
            </span>
            <p className="text-gray-600 text-sm" data-id="element-103">
              Paste any conversation, transcript, or agent log. Synthia distills
              the institutional intelligence embedded in the text and generates
              candidate guardrails for human review.
            </p>
          </div>

          {/* Arrow */}
          <div className="hidden lg:block text-gray-300" data-id="element-104">
            <ArrowRight className="w-8 h-8" data-id="element-105" />
          </div>
          <div className="block lg:hidden text-gray-300" data-id="element-106">
            <ArrowDown className="w-8 h-8" data-id="element-107" />
          </div>

          {/* Step 2 */}
          <div className="flex-1 w-full bg-gray-50 border border-gray-200 rounded-lg p-8 relative" data-id="element-108">
            <span className="text-xs font-mono text-gray-400 mb-2 block" data-id="element-109">
              Step 2
            </span>
            <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Syne']" data-id="element-110">
              Govern
            </h3>
            <span className="inline-block px-2 py-1 bg-orange-100 text-orange-700 text-xs font-bold rounded mb-4" data-id="element-111">
              Synthia CMP
            </span>
            <p className="text-gray-600 text-sm" data-id="element-112">
              Reviewed guardrails flow into Synthia's contextual library, where
              they're structured into constitutional principles. Deploy via MCP
              server with a single line of code.
            </p>
          </div>

          {/* Arrow */}
          <div className="hidden lg:block text-gray-300" data-id="element-113">
            <ArrowRight className="w-8 h-8" data-id="element-114" />
          </div>
          <div className="block lg:hidden text-gray-300" data-id="element-115">
            <ArrowDown className="w-8 h-8" data-id="element-116" />
          </div>

          {/* Step 3 */}
          <div className="flex-1 w-full bg-gray-50 border border-gray-200 rounded-lg p-8 relative" data-id="element-117">
            <span className="text-xs font-mono text-gray-400 mb-2 block" data-id="element-118">
              Step 3
            </span>
            <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Syne']" data-id="element-119">
              Monitor
            </h3>
            <span className="inline-block px-2 py-1 bg-green-100 text-green-700 text-xs font-bold rounded mb-4" data-id="element-120">
              DriftWatch
            </span>
            <p className="text-gray-600 text-sm" data-id="element-121">
              Track all four fidelity signals across every agent in real time.
              When drift crosses thresholds, Recenter automatically re-grounds
              the agent in its constitutional principles.
            </p>
          </div>
        </div>

        {/* Integration Statement */}
        <p className="text-lg text-gray-600 leading-relaxed max-w-3xl" data-id="element-122">
          Add a few lines of code to connect your agent to its constitution.{' '}
          <strong className="text-black font-semibold" data-id="element-123">
            Full governance layer, DriftWatch monitoring, and human-initiated
            re-centering — all included.
          </strong>
        </p>
      </div>
    </section>;
}